import ReactModal from "react-modal";
import GoogleHeart from "@assets/images/google-fit-heart.svg";
import GoogleBack from "@assets/images/GooflefitBack.svg";
import BackImg from "@assets/images/stepsBack.jpg";
import { Switch } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const ConnectGoogle = ({ open, setOpen, handleOpenGoogle }) => {
  const [agree, setAgree] = useState(false);
  const {t} = useTranslation();
  return (
    <ReactModal
      isOpen={open}
      // onRequestClose={() => setOpen(false)}
      className="relative w-[100%] max-w-[90%] lg:max-w-[1006px] h-screen max-h-[75%] bg-white font-[Lato] outline-none !overflow-y-auto rounded-[16px]"
      overlayClassName="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-black/50 z-50"
    >
      <div
        className="flex items-center flex-col h-full p-6 !overflow-y-auto"
        style={{
          backgroundImage: `url(${GoogleBack})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="min-w-[115px] min-h-[115px] bg-[#E8F3FF] rounded-full flex justify-center items-center">
          <img
            src={GoogleHeart}
            alt="GoogleHeart"
            className="min-w-[80px] min-h-[68px]"
          />
        </div>
        <h1 className="text-[24px] font-[600] text-black font-[Lato] mt-3">
          {t("Connect with Google Fit")}
        </h1>
        <p className="text-[20px] font-[Lato] font-[400] mt-1 text-[#9E9E9E]">
          {t("Follow the steps below to enable health data syncing.")}
        </p>
        <div
          className="mt-3 p-8 bg-cover rounded-[16px] w-full"
          style={{ backgroundImage: `url(${BackImg})` }}
        >
          <h1 className="text-[20px] font-[600] font-[Lato] text-white">
            {t("1. Install Google Fit")}
          </h1>
          <p className="text-[16px] font-[400] font-[Lato] text-white">
            {t("Make sure the Google Fit app is installed on your smartphone. If you use a smartwatch, install Google Fit on the watch as well so your steps, heart rate, and activity can sync properly.")}
          </p>
          <h1 className="text-[20px] font-[600] font-[Lato] text-white mt-6">
            {t("2. Use the Same Google Account")}
          </h1>
          <p className="text-[16px] font-[400] font-[Lato] text-white">
           {t("Open Google Fit and log in with the Google account you plan to connect here.Using the same account ensures smooth syncing of your health data.")}
          </p>
          <h1 className="text-[20px] font-[600] font-[Lato] text-white mt-6">
            {t("3. Grant Access to Sync Data")}
          </h1>
          <p className="text-[16px] font-[400] font-[Lato] text-white">
            {t("clickConnect")}
          </p>
        </div>
        <div
          className="flex items-center gap-2 w-full my-3 cursor-pointer"
          onClick={() => setAgree((prev) => !prev)}
        >
          <Switch
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            onClick={(e) => e.stopPropagation()}
          />

          <p className="text-[16px] text-[#383838] font-[Lato] font-[400]">
            {t("Allow Budget Fit Plan to save connected device data for service personalization and advanced reporting.")}
          </p>
        </div>

        <div className="my-3 flex items-center justify-center gap-2">
          <button
            className="py-3 px-10 rounded-full border border-[#0575e6] text-[#0575e6] min-w-[150px] "
            onClick={() => setOpen(false)}
          >
            {t("Close")}
          </button>
          <button
            disabled={!agree}
            onClick={() => handleOpenGoogle()}
            className={`${
              !agree && "opacity-70"
            } py-3 px-10 rounded-full  bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white min-w-[150px]`}
          >
            {t("Continue")}
          </button>
        </div>
      </div>
    </ReactModal>
  );
};
